import { useContext } from 'react';

import { RealTimeLocationContext } from '../contexts/real-time-location';

export function useRealTimeLocation() {
    return useContext(RealTimeLocationContext);
}
